import { filterSelectTriggerClassName } from "@/components/dashboard/active-filters-bar";
import { Label } from "@/components/ui/label";
import { Select } from "@/components/ui/select";
import type { LicenseTypeOption } from "@/types";

interface LicenseTypeFilterProps {
  selectedLicenseTypes: string[];
  onSelectedLicenseTypesChange: (licenseTypes: string[]) => void;
  licenseTypeOptions: LicenseTypeOption[];
}

export function LicenseTypeFilter({
  selectedLicenseTypes,
  onSelectedLicenseTypesChange,
  licenseTypeOptions,
}: LicenseTypeFilterProps) {
  return (
    <div className="w-full shrink-0 md:w-64 md:max-w-full">
      <Label htmlFor="license-type-filter" className="mb-2 block font-bold">
        Filter by License Type
      </Label>
      <Select
        options={licenseTypeOptions}
        value={selectedLicenseTypes}
        onValueChange={onSelectedLicenseTypesChange}
        multiple
        showBadges={false}
        placeholder="Select license types"
        searchPlaceholder="Search license types..."
        emptyMessage="No license type found."
        buttonVariant="default"
        className={filterSelectTriggerClassName(
          selectedLicenseTypes.length > 0,
        )}
      />
    </div>
  );
}
